<template>
  <v-container>
    <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-row>
    <v-row dense class="mt-9" v-else>
      <v-col class="d-flex align-center">
        <v-form v-model="valid" ref="form">
          <v-card
            elevation="1"
            style="background-color: transparent"
            min-height="10vh"
            min-width="70vw"
          >
            <v-card-text>
              <v-file-input
                v-model="avatar"
                ref="fileInput"
                id="fileInput"
                hide-input
                accept="image/*"
                style="visibility: hidden"
              />
              <v-row dense>
                <v-col
                  cols="12"
                  md="3"
                  class="d-flex align-start justify-center"
                >
                  <v-avatar
                    color="primary"
                    size="200"
                    v-if="profile.avatar"
                    @click="triggerFileInput"
                  >
                    <v-img
                      v-if="hasAvatar"
                      contain
                      :src="profile.avatar"
                      rounded
                    />
                    <span v-else class="text-h2 white--text">
                      {{ initials }}
                    </span>
                  </v-avatar>
                </v-col>
                <v-col
                  cols="12"
                  md="9"
                  class="d-flex flex-column justify-center"
                >
                  <span class="text-h4" style="color: #a826e1">{{
                    profile.fullName
                  }}</span>
                  <strong class="text-h5 mt-2"
                    >Tutor: <span class="text-h6">Sim</span></strong
                  >
                  <strong class="text-h5"
                    >Número de alunos: <span class="text-h6">2</span></strong
                  >
                  <strong class="text-h5"
                    >Número de turmas: <span class="text-h6">1</span></strong
                  >
                  <strong class="text-h5"
                    >Qualificações:
                    <span
                      class="text-h6"
                      v-for="(item, index) in profile.certificates"
                      :key="index"
                      >{{ displayCertificateName(item) }}</span
                    ></strong
                  >
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="10"
                  class="d-flex align-center justify-end"
                >
                  <v-btn
                    large
                    rounded
                    outlined
                    color="secondary-500"
                    class="mr-3"
                    @click="returnToHome"
                  >
                    <v-img
                      contain
                      src="@/assets/icons/pink_undo.svg"
                      class="mr-3"
                    ></v-img>
                    <span style="text-transform: none">Voltar</span>
                  </v-btn>
                  <v-btn
                    large
                    rounded
                    color="secondary-500"
                    :loading="loadingSave"
                    @click="submit"
                  >
                    <v-img
                      contain
                      src="@/assets/icons/refresh.svg"
                      class="mr-3"
                    ></v-img>
                    <span class="white--text" style="text-transform: none"
                      >Atualizar</span
                    >
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense class="mt-8">
                <v-tabs
                  v-model="tab"
                  centered
                  icons-and-text
                  background-color="transparent"
                >
                  <v-row dense>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-1"> Dados Gerais </v-tab>
                    </v-col>

                    <v-col
                      class="d-flex justify-center"
                      v-if="profile.pendingInfo"
                    >
                      <v-tab href="#tab-4">
                        <span class="pulsingText"
                          >Experiência profissional</span
                        >
                      </v-tab>
                    </v-col>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-2"> Disponibilidade </v-tab>
                    </v-col>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-3"> Plano de ensino </v-tab></v-col
                    >
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-4"> Financeiro </v-tab></v-col
                    >
                  </v-row>
                  <v-tabs-items
                    v-model="tab"
                    style="background-color: transparent"
                  >
                    <v-tab-item value="tab-1">
                      <v-row dense class="mt-4">
                        <v-card
                          elevation="0"
                          style="background-color: transparent"
                          min-height="10vh"
                          min-width="70vw"
                        >
                          <v-card-text>
                            <v-row dense>
                              <v-col cols="12" md="4">
                                <custom-input
                                  :outlined="true"
                                  v-model="profile.fullName"
                                  label="Nome"
                                  :currentValue="profile.fullName"
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-masked-input
                                  ref="phone"
                                  v-model="profile.phone"
                                  :outlined="true"
                                  label="Telefone"
                                  :currentValue="profile.phone"
                                  :mask="'(##) #####-####'"
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  :outlined="true"
                                  label="Email"
                                  v-model="profile.email"
                                  :currentValue="profile.email"
                                  :customRule="rules.email"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" md="4">
                                <custom-masked-input
                                  ref="document"
                                  :outlined="true"
                                  label="CPF"
                                  :currentValue="profile.document"
                                  :customRule="rules.document"
                                  v-model="profile.document"
                                  :mask="'###.###.###-##'"
                                />
                              </v-col>

                              <v-col cols="12" md="4">
                                <custom-masked-input
                                  :outlined="true"
                                  label="Data de nascimento"
                                  v-model="profile.birthDate"
                                  :currentValue="profile.birthDate"
                                  :mask="'##/##/####'"
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-masked-input
                                  label="CNPJ"
                                  v-model="profile.cnpj"
                                  :outlined="true"
                                  :currentValue="profile.cnpj"
                                  :mask="'##.###.###/####-##'"
                                  :customRule="rules.validCNPJ"
                                />
                              </v-col>
                            </v-row>

                            <v-row
                              dense
                              align="center"
                              justify="center"
                              v-if="profile.underAge"
                              class="mt-4"
                            >
                              <strong style="color: #e85526"
                                >Responsável legal</strong
                              >
                            </v-row>

                            <div
                              v-if="profile.underAge"
                              class="mt-4"
                              style="
                                border-style: solid;
                                border-color: #a0a0a3;
                                border-width: 1px;
                                padding: 2vh;
                                border-radius: 10px;
                              "
                            >
                              <v-row dense>
                                <v-col>
                                  <custom-input
                                    v-model="profile.legalGuardian.name"
                                    :currentValue="profile.legalGuardian.name"
                                    :outlined="true"
                                    label="Nome completo"
                                  ></custom-input>
                                </v-col>
                                <v-col>
                                  <custom-input
                                    :outlined="true"
                                    label="Email"
                                    :customRule="rules.email"
                                    :currentValue="profile.legalGuardian.email"
                                    v-model="profile.legalGuardian.email"
                                  ></custom-input>
                                </v-col>
                                <v-col>
                                  <custom-masked-input
                                    label="Número de telefone do responsável"
                                    placeholder="(11)99999-9999"
                                    hint="ex:(11)1234-5678"
                                    :mask="'(##)#####-####'"
                                    :outlined="true"
                                    v-model="profile.legalGuardian.phone"
                                    :currentValue="profile.legalGuardian.phone"
                                  />
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col>
                                  <custom-masked-input
                                    :outlined="true"
                                    label="CPF"
                                    :mask="'###.###.###-##'"
                                    :customRule="rules.document"
                                    :currentValue="
                                      profile.legalGuardian.document
                                    "
                                    v-model="profile.legalGuardian.document"
                                  />
                                </v-col>
                                <v-col>
                                  <custom-masked-input
                                    :outlined="true"
                                    label="Data de nascimento"
                                    :mask="'##/##/####'"
                                    :customRule="rules.validDate"
                                    :currentValue="
                                      profile.legalGuardian.birthDate
                                    "
                                    v-model="profile.legalGuardian.birthDate"
                                  />
                                </v-col>
                                <v-col>
                                  <div><span>Grau de parentesco</span></div>
                                  <div
                                    class="d-flex align-center justify-center"
                                  >
                                    <v-select
                                      outlined
                                      rounded
                                      background-color="#F1F3F5"
                                      :items="parentGrades"
                                      :item-value="`value`"
                                      :item-text="`text`"
                                      v-model="profile.legalGuardian.kinship"
                                    />
                                  </div>
                                </v-col>
                              </v-row>
                            </div>

                            <v-row dense align="center" justify="center">
                              <span>Endereço</span>
                            </v-row>

                            <v-row dense>
                              <v-col cols="12" md="4">
                                <debounced-input
                                  :outlined="true"
                                  ref="zipCodeInput"
                                  label="CEP"
                                  placeholder="12345678"
                                  hint="Apenas números"
                                  v-model="profile.address.zipCode"
                                  :currentValue="profile.address.zipCode"
                                  @search="getAddressByZipCode"
                                ></debounced-input>
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  ref="streetInput"
                                  :outlined="true"
                                  label="Logradouro"
                                  :currentValue="profile.address.street"
                                  v-model="profile.address.street"
                                  :placeholder="
                                    loadingAddress
                                      ? 'Carregando...'
                                      : 'Nome da rua'
                                  "
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  :outlined="true"
                                  label="Número"
                                  :currentValue="profile.address.number"
                                  v-model="profile.address.number"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" md="4">
                                <custom-input
                                  :outlined="true"
                                  label="Complemento"
                                  :currentValue="profile.address.complement"
                                  v-model="profile.address.complement"
                                  :required="false"
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  :outlined="true"
                                  ref="neighboorhoodInput"
                                  label="Bairro"
                                  :currentValue="profile.address.neighboorhood"
                                  v-model="profile.address.neighboorhood"
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  :outlined="true"
                                  label="Cidade"
                                  ref="cityInput"
                                  :currentValue="profile.address.province"
                                  v-model="profile.address.province"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-row dense class="mt-4">
                        <v-card
                          elevation="0"
                          style="background-color: transparent"
                          min-height="10vh"
                          min-width="70vw"
                        >
                          <v-card-text>
                            <v-row dense align="center" justify="center">
                              <span>Horários</span>
                            </v-row>
                            <v-row
                              dense
                              v-for="(available, index) in profile.aviability"
                              :key="index"
                              align="center"
                            >
                              <v-col cols="12" md="4">
                                <div>Dia da semana</div>
                                <v-select
                                  v-model="available.weekDay"
                                  :items="weekDaysItems"
                                  :item-text="`text`"
                                  :item-value="`value`"
                                  :disabled="!available.editable"
                                  outlined
                                />
                              </v-col>
                              <v-col cols="12" md="3">
                                <div>Início</div>
                                <v-select
                                  v-model="available.from"
                                  outlined
                                  :disabled="!available.editable"
                                  :items="hoursItemsHalf"
                                  @change="updateEnd(available)"
                                />
                              </v-col>
                              <v-col cols="12" md="3">
                                <div>Fim</div>
                                <v-select
                                  v-model="available.to"
                                  outlined
                                  :disabled="!available.editable"
                                  :items="hoursItemsHalf"
                                />
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-btn
                                  icon
                                  @click="
                                    removerDisponibilidade(available.id, index)
                                  "
                                  :disabled="!available.editable"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row align="center" justify="center">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    circle
                                    icon
                                    v-on="on"
                                    v-bind="attrs"
                                    @click="inserirHorario"
                                    ><v-icon>mdi-plus</v-icon></v-btn
                                  >
                                </template>
                                <span>Adicionar horário</span>
                              </v-tooltip>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <v-row
                        no-gutters
                        align="center"
                        justify="center"
                        style="margin-top: 5vh"
                      >
                        <v-col
                          cols="12"
                          md="12"
                          sm="10"
                          class="d-flex align-center justify-end"
                        >
                          <v-btn
                            large
                            rounded
                            color="secondary-500"
                            :loading="loadingSave"
                            @click="openPlanForm"
                          >
                            <v-img
                              contain
                              src="@/assets/icons/plus.svg"
                              class="mr-3"
                            ></v-img>
                            <span
                              class="white--text"
                              style="text-transform: none"
                              >Adicionar</span
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row style="margin-top: 5vh">
                        <v-col
                          cols="12"
                          md="2"
                          class="d-flex align-center justify-center"
                          ><strong>Modalidade</strong></v-col
                        >
                        <v-col
                          cols="12"
                          md="2"
                          class="d-flex align-center justify-center"
                          ><strong>Tempo</strong></v-col
                        >
                        <v-col
                          cols="12"
                          md="2"
                          class="d-flex align-center justify-center"
                          ><strong>Frequência</strong></v-col
                        >
                        <v-col
                          cols="12"
                          md="2"
                          class="d-flex align-center justify-center"
                          ><strong>Valor</strong></v-col
                        >
                        <v-col
                          cols="12"
                          md="2"
                          class="d-flex align-center justify-center"
                          ><strong>Desconto</strong></v-col
                        >
                        <v-col
                          cols="12"
                          md="2"
                          class="d-flex align-center justify-center"
                          ><strong>Ações</strong></v-col
                        >
                      </v-row>
                      <div
                        v-if="teachingPlans.length === 0"
                        class="d-flex align-center justify-center mt-8"
                      >
                        <span>Nenhum resultado encontrado</span>
                      </div>
                      <div v-else>
                        <v-row
                          style="margin-top: 1vh"
                          v-for="(item, index) in teachingPlans"
                          :key="index"
                        >
                          <v-col
                            cols="12"
                            md="2"
                            class="d-flex align-center justify-center"
                            ><strong>{{
                              displayFormat(item.format)
                            }}</strong></v-col
                          >
                          <v-col
                            cols="12"
                            md="2"
                            class="d-flex align-center justify-center"
                            ><strong>{{
                              displayTime(item.time)
                            }}</strong></v-col
                          >
                          <v-col
                            cols="12"
                            md="2"
                            class="d-flex align-center justify-center"
                            ><strong>{{
                              displayFormat(item.frequency)
                            }}</strong></v-col
                          >
                          <v-col
                            cols="12"
                            md="2"
                            class="d-flex align-center justify-center"
                            ><strong style="color: #00d19c">{{
                              Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(item.value)
                            }}</strong></v-col
                          >
                          <v-col
                            cols="12"
                            md="2"
                            class="d-flex align-center justify-center"
                            ><strong style="color: #ffb49d">{{
                              Intl.NumberFormat("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              }).format(item.discount)
                            }}</strong></v-col
                          >
                          <v-col
                            cols="12"
                            md="2"
                            class="d-flex align-center justify-center"
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon circle v-on="on" v-bind="attrs"
                                  ><v-icon>mdi-pencil</v-icon></v-btn
                                >
                              </template>
                              <span>Editar</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon circle v-on="on" v-bind="attrs"
                                  ><v-icon>mdi-delete</v-icon></v-btn
                                >
                              </template>
                              <span>Remover</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <PlansDialog ref="planForm" @savePlan="savePlan" />
                    </v-tab-item>
                    <v-tab-item value="tab-4">
                      <v-row dense align="center">
                        <v-col
                          cols="12"
                          md="6"
                          v-for="(card, index) in cards"
                          :key="index"
                        >
                          <Card :data="card" />
                        </v-col>
                        <v-col cols="12" md="5">
                          <div
                            class="addCard d-flex align-center justify-center"
                            style="min-height: 30vh"
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  plain
                                  v-on="on"
                                  v-bind="attrs"
                                  icon
                                  @click="openCheckout"
                                >
                                  <v-img
                                    contain
                                    width="10vw"
                                    height="10vh"
                                    src="@/assets/icons/card.svg"
                                  />
                                </v-btn>
                              </template>
                              <span>Adicionar cartão de crédito</span>
                            </v-tooltip>
                          </div>
                          <CheckoutDialog ref="checkout" /> </v-col
                      ></v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-4" v-if="profile.pendingInfo">
                      <v-row dense class="mt-4">
                        <v-card
                          style="background-color: transparent"
                          min-height="10vh"
                          min-width="70vw"
                        >
                          <v-card-text>
                            <v-row dense class="mt-4">
                              <v-col>
                                <strong
                                  >Quantos anos de experiência você possui
                                  ?</strong
                                >
                                <v-row dense>
                                  <v-radio-group
                                    :rules="rules.required"
                                    v-model="professionalInfo.yearsOfExperience"
                                  >
                                    <v-radio
                                      v-for="(
                                        experience, index
                                      ) in experiencesLevelsOptions"
                                      :key="index"
                                      :label="experience.text"
                                      :value="experience.value"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row dense class="mt-4">
                              <v-col>
                                <strong
                                  >Qual área de ensino em inglês você se sente
                                  mais confortável dando aula?</strong
                                >
                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(
                                      options, index
                                    ) in techingPreferenceOptions"
                                    :key="index"
                                  >
                                    <v-checkbox
                                      v-model="professionalInfo.expeciality"
                                      :value="options.value"
                                      :label="options.text"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>

                            <v-divider></v-divider>

                            <v-row dense class="mt-4">
                              <v-col>
                                <strong
                                  >Em quais instituições você já
                                  lecionou?</strong
                                >
                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    class="d-flex align-center justify-start"
                                    v-for="(
                                      institution, index
                                    ) in schoolsTypesOptions"
                                    :key="index"
                                  >
                                    <v-checkbox
                                      v-model="professionalInfo.institutions"
                                      :label="institution.text"
                                      :value="institution.value"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>

                            <v-row dense class="mt-4">
                              <v-col>
                                <strong
                                  >Possui experiência em ensino fora do
                                  país?</strong
                                >
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(
                                      options, index
                                    ) in teachingExperiencieAbroadOptions"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      v-model="
                                        professionalInfo.teachingExperiencieAbroad
                                      "
                                      :value="options.value"
                                      :label="options.text"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>

                            <v-row dense class="mt-4">
                              <v-col>
                                <strong
                                  >Quais são as suas áreas de expertise?
                                </strong>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(
                                      options, index
                                    ) in expecialityOptions"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      :value="options.value"
                                      :label="options.text"
                                      v-model="
                                        professionalInfo.teachingPeference
                                      "
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row dense class="mt-4">
                              <v-col>
                                <strong
                                  >Possui certificados de proeficiência?</strong
                                >
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(
                                      options, index
                                    ) in certificatesOptions"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      :value="options.value"
                                      :label="options.text"
                                      v-model="professionalInfo.certificateType"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>

                            <v-row class="mt-4">
                              <v-col>
                                <strong
                                  >O que o motivou a se tornar um professor
                                  licenciado?</strong
                                >
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(
                                      options, index
                                    ) in expectationOptions"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      :value="options.value"
                                      v-model="professionalInfo.motivation"
                                      :label="options.text"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="mt-4">
                              <v-col
                                ><strong
                                  >Quais são as suas expectativas?</strong
                                >
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(
                                      options, index
                                    ) in personalExpectationOptions"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      :value="options.value"
                                      :label="options.text"
                                      v-model="professionalInfo.expectation"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { cnpj, cpf } from "cpf-cnpj-validator";
import addressAPI from "@/shared/addressApi";
import Card from "@/components/checkout/Card.vue";
import partnerApi from "@/shared/pitchPartnerApi";
import { isBefore, isValid, parse, differenceInYears } from "date-fns";
import CheckoutDialog from "@/components/checkout/CheckoutDialog.vue";
import PlansDialog from "@/components/connect/partner/PartnerPlanForm.vue";
export default {
  name: "PartnerProfile",
  components: {
    Card,
    PlansDialog,
    CheckoutDialog,
  },
  mixins: [],
  props: {},
  data() {
    return {
      loading: true,
      loadingSave: false,
      loadingAddress: false,
      valid: false,
      tab: "tab-1",
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      hasAvatar: true,
      avatar: null,
      profile: {
        name: "",
        phone: "",
        email: "",
        document: "",
        birthDate: "",
        password: "",
        legalGuardian: {},
        address: {
          street: "",
          number: "",
          complement: "",
          neighboorhood: "",
          province: "",
          zipCode: "",
        },
        aviability: [],
      },
      teachingPlans: [],
      rules: {
        validDate: [(v) => this.validDate(v) || "Data de nascimento inválida."],
        validCNPJ: [(v) => this.validateCNPJ(v) || "Número de cnpj inválido."],
        document: [
          (v) => this.validateDocNumber(v) || "Número de documento inválido.",
        ],
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+\..+/.test(v) || "Email inválido.",
        ],
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
        required: [(v) => !!v || "Campo obrigatório."],
      },
      cards: [
        {
          current: true,
          name: "NuPagamentos",
          holder: "Sophia Braga",
          maskedNumber: "**** **** **** 1234",
          cvv: "**1",
          expMonth: "02",
          expYear: "2027",
        },
      ],
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
      typeOptions: [
        { text: "Individual", value: "individual" },
        { text: "Dupla", value: "duo" },
        { text: "Trio", value: "trio" },
        { text: "Quarteto", value: "squad" },
      ],
      experiencesLevelsOptions: [
        { value: "LESS_THAN_2_YEARS", text: "Menos de 2 anos" },
        { value: "MORE_THAN_10_YEARS", text: "Mais de 10 anos" },
        { value: "FROM_2_TO_5_YEARS", text: "2-5 anos" },
        { value: "UNEXPERIENCED", text: "Não possuo experiência" },
        { value: "FROM_6_TO_10_YEARS", text: "6-10 anos" },
      ],
      schoolsTypesOptions: [
        { text: "Escolas de idiomas", value: "language_schools" },
        { text: "Aulas particulares", value: "particular_classes" },
        { text: "Cursos online", value: "online_courses" },
        { text: "Escolas regulares", value: "regular_schools" },
        { text: "Não possuo Experiência", value: "unexperienced" },
      ],
      teachingExperiencieAbroadOptions: [
        { value: "exchange", text: "Intercâmbio" },
        { value: "social_projects", text: "Projeto Social" },
        { value: "work", text: "Trabalho" },
        { value: "other", text: "Outro" },
        { value: "tourism", text: "Turismo" },
        { value: "unexperienced", text: "Não possuo experiência" },
      ],
      expecialityOptions: [
        { text: "Conversação", value: "conversation" },
        { text: "Organização de exame", value: "exam_creation" },
        { text: "Gramática", value: "grammar" },
        { value: "other", text: "Outro" },
        { text: "Ingês instrumental", value: "instrumental_english" },
        { text: "Não possuo", value: "dont_have" },
      ],
      academicFormationOptions: [
        { text: "Ensino fundamental", value: 1 },
        { text: "Mestrado", value: 4 },
        { text: "Ensino médio", value: 2 },
        { text: "Doutorado", value: 5 },
        { text: "Ensino superior", value: 3 },
      ],
      certificatesOptions: [
        { text: "TOEFL", value: "TOEFL" },
        { text: "TOEIC", value: "TOEIC" },
        { text: "IELTS", value: "IELTS" },
        { text: "PTE", value: "PTE" },
        { text: "Cambridge", value: "CAMBRIDGE" },
        { text: "MET", value: "MET" },
        { text: "Não possuo", value: "dont_have" },
      ],
      expectationOptions: [
        { text: "Oportunidade de negócio", value: "bussiness" },
        { text: "Realização pessoal", value: "personal_growth" },
        { text: "Flexibilidade de horários", value: "flexible_hours" },
        { text: "Liberdade geográfica", value: "geographical_freedom" },
        { text: "Paixão pelo ensino", value: "love_for_teaching" },
        { text: "Outros", value: "other" },
      ],
      personalExpectationOptions: [
        { text: "Crescimento financeiro", value: "financial_growth" },
        { text: "Negócio próprio", value: "own_bussiness" },
        { text: "Desenvolvimento profissional", value: "professional_growth" },
        { text: "Outros", value: "other" },
        { text: "Flexibilidade", value: "flexibility" },
      ],
      techingPreferenceOptions: [
        { text: "Conversação", value: "conversation" },
        { text: "General english", value: "general_english" },
        { text: "Gramática", value: "grammar" },
        { text: "Personalizada", value: "personalized" },
        { text: "Instrumental", value: "instrumental" },
        { text: "Outra", value: "other" },
      ],
      adaptationOptions: [
        { text: "Totalmente de acordo", value: "AGREE" },
        { text: "Não consigo opinar agora", value: "NEUTRAL" },
        { text: "Parcialmente de acordo", value: "PARTIALY_AGREE" },
        { text: "Discordo", value: "DISAGREE" },
      ],
      parentGrades: [
        { text: "Pai/Mãe", value: 1 },
        { text: "Padrasto/Madrasta", value: 2 },
        { text: "Tio/Tia", value: 3 },
        { text: "Avô/Avó", value: 4 },
        { text: "Responsável legal", value: 5 },
        { text: "Outro", value: 6 },
      ],
      professionalInfo: {
        yearsOfExperience: null,
        institutions: [],
        teachingExperiencieAbroad: [],
        expeciality: [],
        academicFormation: null,
        hasCertificate: false,
        certificateType: [],
        diferential: "",
        teachingPeference: [],
        motivation: [],
        expectation: [],
      },
      hoursItemsHalf: [
        "06:00",
        "06:30",
        "07:00",
        "07:30",
        "08:00",
        "08:30",
        "09:00",
        "09:30",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
        "20:30",
        "21:00",
        "21:30",
        "22:00",
      ],
    };
  },
  computed: {
    initials() {
      return `${this.profile.name
        .split(" ")[0]
        .substring(0, 1)} ${this.profile.name.split(" ")[1].substring(0, 1)}`;
    },
  },

  async mounted() {
    this.loadData();
  },
  created() {},
  methods: {
    async loadData() {
      await Promise.all([
        partnerApi.showProfile().then(async (res) => {
          this.profile = Object.assign({}, res.data);
          this.loading = false;
        }),
        partnerApi.getPartnerPlans().then((res) => {
          this.teachingPlans = res.data.data;
        }),
      ]);
    },
    openCheckout() {
      this.$refs.checkout.open();
    },
    validateDocNumber(doc) {
      return cpf.isValid(doc);
    },
    validDate(date) {
      const inputedDate = parse(date, "dd/MM/yyyy", new Date());
      return isValid(inputedDate) && isBefore(inputedDate, new Date());
    },
    validateCNPJ(doc) {
      if (!doc) return true;
      return cnpj.isValid(doc);
    },
    returnToHome() {
      this.$router.push({
        path: "cockpit",
      });
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loadingSave = true;
        if (this.avatar) {
          const formData = new FormData();
          formData.append("avatar", this.avatar);
          await partnerApi
            .uploadFiles(formData)
            .then((res) => {
              this.profile.avatar = res.data.ok;
            })
            .finally(() => {});
        }

        if (this.profile.pendingInfo) {
          if (this.professionalInfo.certificateType.length > 0)
            this.professionalInfo.hasCertificate = true;

          this.profile.aditionalInfo = this.professionalInfo;
        }
        partnerApi
          .updateProfile(this.profile)
          .then(() => {
            this.$root.$emit("display-alert", {
              text: "Perfil atualizado com sucesso!",
              type: 0,
            });
            this.loadData();
          })
          .catch(() => {
            this.$root.$emit("display-alert", {
              text: "Ocorreu um problema na validação, verifique os campos.",
              type: 1,
            });
          })
          .finally(() => {
            this.loadingSave = false;
          });
      } else {
        this.$root.$emit("display-alert", {
          text: `Por favor preencha todos os campos obrigatórios!`,
          type: 1,
        });
      }
    },
    getAddressByZipCode() {
      if (this.profile.address.zipCode) {
        addressAPI
          .getAddresByZipCode(this.profile.address.zipCode)
          .then(async (res) => {
            this.$refs.streetInput.handleInput(res.data.address);
            this.$refs.neighboorhoodInput.handleInput(res.data.district);
            this.$refs.cityInput.handleInput(
              res.data.city + ` - ${res.data.state}`
            );
            this.readOnly = false;
            this.loadingAddress = false;
          })
          .catch(() => {
            this.loadingAddress = false;
            this.readOnly = false;
          });
      }
    },
    openPlanForm() {
      this.$refs.planForm.openDialog();
    },
    savePlan(data) {
      partnerApi.createPartnerPlan(data).then((res) => {
        this.$refs.planForm.closeDialog();
        this.teachingPlans.push(res.data);
        this.$root.$emit("display-alert", {
          text: "Plano adicionado com sucesso.",
          type: 0,
        });
      });
    },
    displayFormat(format) {
      switch (format) {
        case 1:
          return "Individual";
        case 2:
          return "Dupla";
        case 3:
          return "Trio";
        case 4:
          return "Quarteto";
      }
    },
    displayTime(time) {
      return time === 1 ? "1 Hora" : "90 minutos";
    },
    displayFrequency(frequency) {
      return `${frequency}x semana`;
    },
    triggerFileInput() {
      document.getElementById("fileInput").click();
    },
    displayCertificateName(name) {
      return name === "dont_have" ? "Não possui" : name;
    },
    updateEnd(av) {
      if (!av.from || !this.profile.perClass) return;

      const [h, m] = av.from.split(":").map(Number);
      const d = new Date(2000, 0, 1, h, m);
      d.setMinutes(d.getMinutes() + this.profile.perClass);

      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");

      const result = `${hh}:${mm}`;
      av.to = this.hoursItemsHalf.includes(result) ? result : null;
    },
    async removerDisponibilidade(id, index) {
      if (id) {
        await partnerApi
          .removerDisponibilidade(id)
          .then(() => {
            this.$root.$emit("display-alert", {
              text: "Disponibilidade atualizada com sucesso!",
              type: 0,
            });
            this.loadData();
          })
          .catch(() => {
            this.$root.$emit("display-alert", {
              text: `Ocorreu um pequenino problema ao atualizar sua disponibilidade, tente novamente mais tarde!`,
              type: 1,
            });
          });
      } else {
        this.profile.aviability.splice(index, 1);
      }
    },
    async inserirHorario() {
      this.profile.aviability.push({
        weekDay: null,
        from: null,
        to: null,
        editable: true,
      });
    },
  },
  watch: {
    "profile.birthDate": {
      handler: function (value) {
        if (value) {
          try {
            const birthDate = parse(value, "dd/MM/yyyy", new Date());

            const difference = differenceInYears(new Date(), birthDate);
            if (difference < 18) {
              this.profile.underAge = true;
            } else {
              this.profile.underAge = false;
            }
          } catch (e) {
            return e;
          }
        }
      },
      deep: true,
    },
    avatar: function (value) {
      if (value) {
        this.profile.avatar = URL.createObjectURL(value);
        this.hasAvatar = true;
      }
    },
  },
};
</script>
<style scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.image-col {
  position: relative;
}

.overflow-image {
  position: absolute;
  top: -17.5vh;
  right: 0;
}

.normal {
  text-transform: none;
}

.pulsingText {
  color: #ff5d2a;
  animation: pulse 2s infinite;
  border-radius: 30%;
  padding: 1vh;
}

.alert {
  color: #e85526;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(144, 0, 222, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 1rem rgba(144, 0, 222, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(144, 0, 222, 0);
  }
}
</style>
